import classNames from 'classnames';
import { MFLink } from '@medifind/shared-basic-components';
import styles from './CardOrgLogo.module.scss';

const CardOrgLogo = ({ orgWebsite, orgLogo, primaryOrgName, className }) => {
  if (!orgLogo) {
    return <div className={classNames(styles['org-logo'], className)} />;
  }
  return (
    <>
      {orgWebsite ? (
        <div className={classNames(styles['org-logo'], className)}>
          <MFLink analyticsLinkType={'person-org-link'} to={orgWebsite} target="_blank">
            <img src={`${orgLogo}-350x350.png`} alt={primaryOrgName} />
          </MFLink>
        </div>
      ) : (
        <div className={classNames(styles['org-logo'], className)}>
          <img src={`${orgLogo}-350x350.png`} alt={primaryOrgName} />
        </div>
      )}
    </>
  );
};

export { CardOrgLogo as default, CardOrgLogo };
